import React from 'react';
import {Select} from './Select';
import {FieldProp} from '../../types';

type WorkflowUserProps = FieldProp & {};

export const WorkflowUser: React.FunctionComponent<WorkflowUserProps> = (props): JSX.Element => {

    // override default etl config with custom values
    if (props.field?.flowCustomDisplayComponentConfig?.etlConfig) {
        props.field.etlConfig = {
            ...props.field.etlConfig,
            ...props.field?.flowCustomDisplayComponentConfig?.etlConfig
        }
    }

    // TODO - this unfortunately wipes out any existing onSelect config, which is okay for now
    //        but should be fixed for long-term
    if (props.field?.flowCustomDisplayComponentConfig?.onChangePipeline) {
        if (!props.field.etlConfig?.onSelect) {
            props.field.etlConfig.onSelect = [
                ...props.field.flowCustomDisplayComponentConfig.onChangePipeline
            ];
        }
    }
    if (props.field?.flowCustomDisplayComponentConfig?.fillMap) {
        props.field.etlConfig.fillMap = props.field.flowCustomDisplayComponentConfig.fillMap;
    }

    return (
        <Select {...props} placeholder="Begin typing user email address"/>
    );
};